import React from 'react';
import { useDataContext } from 'common/lib/helpers/DataContext';
import { concatImagesAndFloorplans } from 'common/lib/helpers/ImageHelpers';
import { ImageGallery } from '@finn-no/object-page-image-gallery-component';
import { trackEventImageGalleryFullscreen, trackEventImageGalleryNext } from 'common/lib/helpers/trackingService';

const ImageCarousel = () => {
    const data = useDataContext();
    const { images, pictureUrl, floorPlans, finnkode } = data;

    const imagesAndFloorPlan = concatImagesAndFloorplans(images, floorPlans);
    const formattedGalleryImages = imagesAndFloorPlan.map(image => {
        return { description: image.caption, width: image.width, height: image.height, uri: pictureUrl + image.path };
    });

    return (
        <div className="relative">
            <ImageGallery
                images={formattedGalleryImages}
                adId={finnkode}
                trackNavigation={trackEventImageGalleryNext}
                trackLightBox={trackEventImageGalleryFullscreen}
            />
        </div>
    );
};

export default ImageCarousel;
